import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { usePolling } from 'hooks/usePolling'
import { fetchUnreadCount, selectUnreadNotificationCount } from 'slices/notificationSlice'

export const UNREAD_POLL_MS = 60_000

/**
 * The bell's unread count, kept fresh (MYD-542): polled about once a minute
 * while the tab is visible, and at once on returning to it.
 *
 * Only one bell is mounted at a time (the desktop header or the field
 * header), so each polls for itself rather than through a provider.
 */
export function useUnreadNotifications(): number {
	const dispatch = useDispatch<any>()
	const signedIn = useSelector((state: any) => Boolean(state.userLogin?.userInfo))
	const count = useSelector(selectUnreadNotificationCount)

	const poll = useCallback(() => {
		dispatch(fetchUnreadCount())
	}, [dispatch])
	usePolling(poll, UNREAD_POLL_MS, { enabled: signedIn })

	return count
}

export default useUnreadNotifications
